import styled from '../../../theme/theme';

export const StyledIframe = styled.iframe<{ isLoading: boolean }>(
  ({ theme: { radii }, isLoading }) => ({
    width: '100%',
    height: '100%',
    borderTopRightRadius: radii.large,
    borderTopLeftRadius: radii.large,
    border: 'none',
    display: isLoading ? 'none' : 'block',
  }),
);
